const sideContentText = { 
    en: {  
        grass:'Grass',
        sand:'Sand',
        candidate:'Candidate',
        age:'Years',
        meters:'meters',
        M:'Horse',
        H:'Mare',
        g1:'G1',
        g2:'G2',
        g3:'G3',
        handicap:'Handicap',
        clasico:'Classic',
        l:'L',
        especial:'Special',
        normal:'Fast Track',
        pesada:'Good Track',
        fangosa:'Muddy Track',
        humeda:'Wet Track',
    },
    es: {  
        grass:'Césped',
        sand:'Arena',
        candidate:'Candidato',
        age:'Años',
        meters:'metros',
        M:'Macho',
        H:'Hembra',
        g1:'G1',
        g2:'G2',
        g3:'G3',
        handicap:'Handicap',
        clasico:'Clásico',
        l:'L',
        especial:'Especial',
        normal:'Pista Normal',
        pesada:'Pista Pesada',
        fangosa:'Pista Fangosa',
        humeda:'Pista Húmeda',
    },
    pt: {  
        grass:'Grama',
        sand:'Areia',
        candidate:'Candidato',
        age:'Anos',
        meters:'metros',       
        M:'Cavalo',
        H:'Égua',
        g1:'G1',
        g2:'G2',
        g3:'G3',
        handicap:'Handicap',
        clasico:'Clássico',
        l:'L',
        especial:'Especial',
        normal:'Pista Rápida',
        pesada:'Pista Boa',
        fangosa:'Pista Encharcada',
        humeda:'Pista Molhada',
    },
}

export default sideContentText;